<div class="main-header pl-2 pr-2 lg:pl-4 md:pr-4 bg-primary main-top-header no-print">
    <div class="grid mt-0">
        <div
            class="col-12 md:col-4 lg:col-4 xl:col-4 flex justify-content-center md:justify-content-start align-items-center">
            <img (click)="goToMainPage()" src="./assets/img/tlogo4.svg" class="cursor-pointer" alt="logo" width="204"
                height="37">
            <span class="h4 text-gray-400 border-left-1 border-gray-400 pl-2 ml-2"> {{ 'COMMON.HEADER.APP_NAME' | translate }} </span>
        </div>
        <div class="col-12 md:col-6 lg:col-6 xl:col-7">
            <div class="flex justify-content-center md:justify-content-end align-items-center pt-2 pb-2 gap-3">
                <!-- Language switcher: visible to ALL users, placed before profile.
                     Sélecteur de langue : visible pour TOUS, placé avant le profil. -->
                @if (canSwitchLanguage$ | async) {
                <div class="flex align-items-center gap-1">
                    <button pButton
                        [class]="locale === 'en' ? 'p-button-sm text-xs p-button-secondary' : 'p-button-sm text-xs p-button-outlined p-button-secondary'"
                        (click)="switchLocale('en')"
                        [attr.aria-pressed]="locale === 'en'"
                        aria-label="Switch to English">
                        EN
                    </button>
                    <button pButton
                        [class]="locale === 'fr' ? 'p-button-sm text-xs p-button-secondary' : 'p-button-sm text-xs p-button-outlined p-button-secondary'"
                        (click)="switchLocale('fr')"
                        [attr.aria-pressed]="locale === 'fr'"
                        aria-label="Passer en français">
                        FR
                    </button>
                </div>
                }
                @if (authState$ | async) {
                <p-avatar *ngIf="!(authState$ | async)?.avatar" class="flex" icon="pi pi-user" shape="circle"></p-avatar>
                <p-avatar *ngIf="(authState$ | async)?.avatar" class="flex" [image]="(authState$ | async)?.avatar"
                    shape="circle"></p-avatar>
                <div class="text-white"> {{(authState$ | async)?.firstName}} {{(authState$ | async)?.lastName}}</div>
                }
            </div>
        </div>
        <div
            class="col-12 md:col-2 lg:col-2 xl:col-1 flex justify-content-end md:justify-content-end align-items-center">
            <div>
                <button pButton (click)="logout()"
                    class="p-button-sm text-sm text-white p-button-outlined p-button-secondary p-button-outlined">
                    {{ 'COMMON.HEADER.LOGOUT' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
